import React from 'react';
import { useT } from '@transifex/react';
import { getMailSubscriptionRequest } from '@raisin/cp-utils';
import { Newsletter as NewsletterForm } from '@raisin/components-lib';
import { getResponseCodes, submitRequest } from './api';
import { NewsletterProps } from './types';
import messages from 'messages';

export const Newsletter: React.FC<NewsletterProps> = (props) => {
  const t = useT();
  const responseCodes = getResponseCodes(messages, t);

  const handleSubmit = (values, successHandler, errorHandler) => {
    submitRequest({
      request: getMailSubscriptionRequest(values.subscriptionEmail),
      email: values.subscriptionEmail,
      successHandler,
      errorHandler,
    });
  };

  return (
    <NewsletterForm
      responseCodes={responseCodes}
      onSubmit={handleSubmit}
      formInvalidEmailFormat={t(messages.FormInvalidEmailFormat)}
      formRequiredField={t(messages.FormRequiredField)}
      {...props}
    />
  );
};
